<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";

export default {
  name: "TaxReturnTable",
  components: {TaxReturnTableRow}
}
</script>

<template>
  <table>
    <colgroup>
      <col span="1" style="width: 50%;">
      <col span="2" style="width: 25%;">
    </colgroup>

    <thead>
    <slot name="header"/>
    </thead>

    <tbody>
    <slot name="body"/>
    </tbody>
  </table>
</template>

<style scoped lang="scss">
table {
  width: 100%;
}
</style>